import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  taskTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/tasks/templates'
import { TaskTemplateRole } from '@core/entities/task/TaskTemplateRole'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useDeleteTaskTemplateRole = (
  options?: UseMutationOptions<
    TaskTemplateRole,
    RequestErrorType,
    RequestTypes['deleteTaskTemplateRole']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...taskTemplateKeys.deleteTaskTemplateRole,
    ...options,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: taskTemplateKeys.getTaskTemplateRoles({
          templateId: variables.templateId,
          versionId: variables.versionId,
        }).queryKey,
      })
    },
  })
}
